import { createAction } from 'redux-actions';

export const updateGuestVisitSearchQuery = createAction(
  'UPDATE_GUEST_VISIT_SEARCH_QUERY'
);
